import { Action, createReducer, on } from '@ngrx/store';
import { IAsqEmployerItem } from '../models/asq-employers.model';
import * as asqEmployersActions from '../actions/asq-employers.actions';

export const asqEmployersFeatureKey = 'asqEmployers';

export interface AsqEmployersState {
  loadAsqEmployersResponse: IAsqEmployerItem[];
  loadAsqEmployersFailure: Error | any;
}

export const initialState: AsqEmployersState = {
  loadAsqEmployersResponse: undefined,
  loadAsqEmployersFailure: undefined
};

export const reducer = createReducer(
  initialState,
  on(asqEmployersActions.loadAsqEmployersSuccess, (state, action) => ({
    ...state,
    loadAsqEmployersResponse: action.response
  })),
  on(asqEmployersActions.loadAsqEmployersFailure, (state, action) => ({
    ...state,
    loadAsqEmployersFailure: action.error
  }))
);

export const getAsqEmployers = (state: AsqEmployersState) => state.loadAsqEmployersResponse;
